var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"avatar",attrs:{"src":_vm.pathImg,"alt":"Avatar"}}),_vm._t("name-avatar",function(){return [_vm._v("Name User")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }